
    import './styles.scoped.css';
    export default {
  "resizable-box": "awsui_resizable-box_cufu9_1bz1l_17",
  "resizable-box-handle": "awsui_resizable-box-handle_cufu9_1bz1l_22",
  "resize-active": "awsui_resize-active_cufu9_1bz1l_63"
};
  